<template>
  <div class="common-row">
    <label class="row-label" :class="{ 'align-start': labelStart }" :style="{ width: labelWidth }">
      {{ label }}
      <s-tooltip v-if="tip" class="question-tip" :transfer="true" :content="tip" placement="bottom">
        <s-icon icon="question"></s-icon>
      </s-tooltip>
      <i class="required-mark" v-if="required">*</i>
    </label>
    <div class="row-content" :style="{ width: contentWidth }">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: '',
  props: {
    label: {
      type: String,
      default: '',
    },
    labelWidth: {
      type: String,
    },
    contentWidth: {
      type: String,
      default: '100%',
    },
    required: {
      type: Boolean,
      default: false,
    },
    labelStyle: {
      type: Object,
      default() {
        return {}
      },
    },
    labelStart: {
      type: Boolean,
      default: false,
    },
    tip: {
      type: String,
      default: '',
    },
  },
  data() {
    return {}
  },
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
.common-row
  display: flex;
  margin-bottom: 15px;
  align-items: center;
  .row-label
    flex-shrink: 0;
    text-align: right;
    margin-right: 15px;
    line-height: 30px;
    position: relative;
    &.align-start
      align-self: flex-start;
    .required-mark
      color: #ed5565;
      position: absolute;
      right: -10px;
      top: 3px;
    .question-tip
      color: #b8b8b8;
      cursor: pointer;
      vertical-align: middle;
      height: 100%;
  .row-content
    text-align: left;
    align-items: center;
    width: 100%;
</style>
